import styled from 'styled-components'
import {maxWidth} from 'core/theme'

export const Wrapper = styled.div`
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 109px;
  background-color: #FFFFFF;
  z-index: 20;
  ${maxWidth.medium`
    height: 61px;
    box-shadow: 0px 0px 3px 0 rgba(0, 0, 0, 0.26);
  `};
`
export const SubHeader = styled.div`
  height: 28px;
  background-color: #f8f8f8;
  border: 1px solid #DEDEDE;
  ${maxWidth.medium`
    display: none;
  `};
`

export const Left = styled.div`
  svg{
    width: 364px;
    height: 119px;    
    margin-top: 30px;
    margin-left: 20px;
    z-index: 11; //Menus have z-index: 10
    ${maxWidth.large`
      width: 300px;
      height: 100px;
      margin-left: 10px;
    `};
    ${maxWidth.medium`
      width: 157pt;
      height: 70pt;
      margin-top: 15px;
      margin-left: 8px;
    `};
    ${maxWidth.xsmall`
      width: 138pt;
      height: 75pt;
      margin-left: 4px; 
    `};
  }
`

export const Right = styled.div`
  width: auto;
  height: 100%;
  background-color: #ffffff;
`

export const RightMobile = styled.div`
  display: inline-flex;
`

export const RightDesktop = styled.div`
  height: 100%;
  .header-bar {
    height: 50%;
    width: 100%;
  }
  .header-icon-container {
    .edit-menu__wrap {
      position: relative;
    }
    .edit-menu {
      display: none;
      position: absolute;
      z-index: 3;
      top: 0;
      right: 0;
      width: 163px;
      padding: 24px;
      background-color: #fff;
      box-shadow: 0 1px 5px 0 rgba(0,0,0,.2);
      border-radius: 4px;
      &__options {
        list-style-type: none;
        padding: 0;
        margin: 0;
        position: relative;
        li + li {
          margin-top: 6px;
          a {
            line-height: 1.75;
          }
        }
      }
    }
    .header-unread-count {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fe5147;
      color: #fff;
      display: inline-block;
      text-align: center;
      position: relative;
      right: 10px;
      bottom: 10px;
      font-size: 10px;
      line-height: 16px;
    }
    .header-unread-count__menu {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      color: #fff;
      display: inline-block;
      background-color: #fe5147;
      text-align: center;
      position: relative;
      left: 6px;
      bottom: 4px;
      font-weight: bold;
      font-size: 10px;
      line-height: 16px;
    }
    float: right;
    margin-right: 32px;
    margin-top: 16px;
    line-height: 1;
    //&.user-menu {
    //  padding-left: 32px;
    //  border-left: 1px solid #dedede;
    //}
    > a, > div > a {
      display: inline-block;
      font-family: "Lato", "Arial", sans-serif;
      font-size: 0.8125rem;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #007acc;
      vertical-align: middle;
      span {
        margin-left: 7px;
        vertical-align: middle;
      }
      svg {
        vertical-align: middle;
      }
    }
  }
`
